import { useEditStore } from '../../hooks';
import { EnvironmentRegistrationModalView } from '../../components/EnvironmentRegistrationModalView';

export const EnvironmentEditModal = () => {
  const editStore = useEditStore();

  return <EnvironmentRegistrationModalView {...editStore} />;
};
